// extracted by mini-css-extract-plugin
export default {"container":"whatsapp-button_container__Q66Qv","icon":"whatsapp-button_icon__mhTQT"};